// extracted by mini-css-extract-plugin
export default {"container":"not-found-404_container__DyfRQ","code":"not-found-404_code__mcKU7","text":"not-found-404_text__HT7Mm"};